function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 7.81853C8 8.07593 7.90396 8.33331 7.71229 8.52956L1.67776 14.7051C1.29388 15.098 0.671503 15.098 0.287787 14.7051C-0.095929 14.3124 -0.095929 13.6756 0.287787 13.2827L5.62748 7.81853L0.287973 2.35428C-0.0957425 1.96143 -0.0957425 1.32469 0.287973 0.932032C0.67169 0.538995 1.29407 0.538995 1.67794 0.932032L7.71248 7.1075C7.90418 7.30384 8 7.56122 8 7.81853Z",
  fill: "#D34714"
});

var SvgSkipArrow = function SvgSkipArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSkipArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/skip-arrow.043e99de.svg";
export { ForwardRef as ReactComponent };